import { useQuery } from "react-query";
import AxiosT from "../../setup/setup-axios-bearer";

async function fetchGetSaleFactorDetail(id) {
  const res = await AxiosT.get(`/out-warehouse-with-factor?id=${id}`);
  return res.data;
}

export function useGetSaleFactorDetail(id) {
  return useQuery(["getSaleFactordetail", id], () =>
    fetchGetSaleFactorDetail(id)
  );
}
